import { render, staticRenderFns } from "./scrEndScoringError.vue?vue&type=template&id=555e71a6&scoped=true"
import script from "./scrEndScoringError.vue?vue&type=script&lang=js"
export * from "./scrEndScoringError.vue?vue&type=script&lang=js"
import style0 from "./scrEndScoringError.vue?vue&type=style&index=0&id=555e71a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "555e71a6",
  null
  
)

export default component.exports